/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('./dependencies/third-party/importThirdPartyDependencies');
require('../knockApp.module');
require('./dependencies/legacyAngularAppDependencies');
